/* eslint-disable */ 
import React from 'react'
import styles from '../../../../containers/Forms/TkAndCrpForms.css'

const TextInput = props => {
  const {
    input,
    meta: { touched, error, warning },
    label,
    getLabel,
    required,
    autoFocus,
    placeholder,
    disabled,
    inline,
    showRedRequiredIcon,
    type = 'text',
    icon,
    handleIconClick = () => {},
  } = props

  const inputComponent = typeof getLabel === 'function'
    ? getLabel()
    : <span className={styles.label}>{label}</span>

  const cn = inline ? styles.inputRowGroup : styles.inputGroup

  return (
    <label
      className={cn}
      htmlFor={input.name}
    >
      <div className={styles.labelWrapper}>
      {required &&
        <span className={styles.required} />
      }
      {showRedRequiredIcon &&
        <span className={styles.required} />
      }
      {inputComponent}
      </div>
      <div className={styles.inputWrapper}>
        <input
          {...input}
          autoComplete="off"
          className={styles.input}
          type={type}
          disabled={disabled}
          required={required}
          id={input.name}
          autoFocus={autoFocus}
          placeholder={placeholder}
        />
        {
          icon && <span className={styles.inputIcon} onClick={() => handleIconClick(type, input.name)}>{icon}</span>
        }
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </label>
  )
}

export default TextInput


// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/CrpTextInput/TextInput.jsx